enum SFDCAppScope {
    default = 'default',
    report = 'report',
}

export default SFDCAppScope;
